import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TdLoadingService, TdDialogService } from '@covalent/core';
import { MdSelect } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';

import { MotivosService, MasterService, LoginService } from '../../../../../services/';

import { Motivo } from '../../../../../models';

@Component({
  selector: 'qs-motivosdetalle',
  styleUrls: ['./motivosdetalle.component.scss'],
  templateUrl: './motivosdetalle.component.html',
  viewProviders: [MotivosService, MasterService],
})

export class MotivosDetalleComponent implements AfterViewInit, OnDestroy {

  private mode: string;
  private title: string;

  private idPaciente: string;
  private visita: string;
  private colegiado: string;
  private accion: string;

  private motivo: Motivo;
  private oldMotivo: Motivo;

  constructor(private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _master: MasterService,
    private _motivosService: MotivosService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef, ) {
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.colegiado = this._loginService.colegiado;
    this.visita = this._loginService.consulta.visita;
    this.motivo = new Motivo();
    this.oldMotivo = new Motivo();
    if (this._loginService.transient) {
      this.mode = 'edit';
      this.title = 'Editar';
      this.motivo = this._loginService.transient;
    } else {
      this.mode = 'add';
      this.title = 'Añadir';
    }
  }

  ngAfterViewInit(): void {
    this._changeDetectorRef.detectChanges();
  }

  delete(form: NgForm): void {
    this.mode = 'del';
    this.save(form);
  }

  save(form: NgForm): void {
    let fecha: Date = new Date();
    let message: string = '';
    let error: string = '';
    let messages: string[] = [
      'Motivo Añadido correctamente.', 'Error añadiendo Motivo.',
      'Motivo Actualizado correctamente.', 'Error actualizando Motivo.',
      'Motivo Borrado correctamente.', 'Error borrando Motivo'];
    let hora: string = fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
    switch (this.mode) {
      case 'edit':
        this.accion = 'M';
        message = messages[2];
        error = message[3];
        break;
      case 'add':
        this.accion = 'I';
        message = messages[0];
        error = messages[1];
        break;
      case 'del':
        this.accion = 'B';
        message = messages[4];
        error = messages[5];
        break;
      default: break;
    }

    if (form.valid) {
      this._loadingService.register();
      let params: any = {
        iNumMotivo: this.accion !== 'I' ? this.motivo.numeroMotivo : '',
        iNumExpediente: this.idPaciente,
        iFecha: fecha,
        iNumVisita: this.visita,
        iDniMed: this._loginService.profesional.Dni,
        iLinea: 0,
        iColegiado: this.colegiado,
        iTexto: this.motivo.texto,
        iHora: hora,
        iAccion: this.accion,
      };
      this._motivosService.guardarMotivo(params).subscribe((res: any) => {
        if (res) {
          this._loginService.motivo = res;
          this._loginService.mostrarMensaje(message, 'OK', 6000);
          this._loadingService.resolve();
          this.mode = 'save';
          this._router.navigate(['/main/consulta/' + this.idPaciente + '/hojadeseguimiento', { outlets: { hojadeseguimiento: ['motivos'] } }]);
        } else {
          this._loginService.mostrarMensaje(message, 'OK', 6000);
          this._loadingService.resolve();
        }
      }, (resError: Error) => {
        this._loginService.mostrarMensaje('Error procesando el alta', 'OK', 6000);
        this._loadingService.resolve();
      });
    }
  }

  canDeactivate(): Promise<boolean> | boolean {
    if (this.oldMotivo.texto === this.motivo.texto) {
      return true;
    } else {
      if (this.mode !== 'save') {
        return new Promise((resolve: any) => {
          this._dialogService.openConfirm({
            message: 'Si pulsa aceptar, se perderán los datos introducidos.',
            title: '¿Desea abandonar el alta de motivo?',
            acceptButton: 'Aceptar',
            cancelButton: 'Cancelar',
          }).afterClosed().subscribe((accept: boolean) => {
            if (accept) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        });
      } else {
        return true;
      }
    }
  }

  ngOnDestroy(): void {
    this._loginService.transient = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/hojadeseguimiento/motivosconsulta/motivosconsultadetalle/motivosdetalle.component.ts